import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable()
export class DialogService {

    public invalidDateAlert() {
        return this.errorAlert('Errore', 'Data Non Valida!');
    }

    public ws400alert(message?: string) {
        if (message) {
            return this.errorAlert('Errore', message);
        } else {
            return this.errorAlert('Errore', 'Dati non validi');
        }
    }

    public ws403alert() {
        return this.errorAlert('Errore', 'Operazione non autorizzata');
    }

    public ws404alert() {
        return this.errorAlert('Errore', 'Risorsa richiesta non trovata');
    }

    public ws500alert() {
        return this.errorAlert('Errore', 'Si è verificato un errore interno');
    }


    public standardAlert(title: string, message: string) {
        return this.alert(title, message);
    }

    public errorAlert(title: string, message: string) {
        return this.alert(title, message, 'error');
    }

    public warningAlert(title: string, message: string) {
        return this.alert(title, message, 'warning');
    }

    public infoAlert(title: string, message: string) {
        return this.alert(title, message, 'info');
    }

    public successAlert(title: string, message: string) {
        return this.alert(title, message, 'success');
    }

    public questionConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback: Function) {
        return this.confirm(title, message, 'question', yesBtn, noBtn, yesCallback, noCallback);
    }

    public infoConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback: Function) {
        return this.confirm(title, message, 'info', yesBtn, noBtn, yesCallback, noCallback);
    }

    public warningConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback: Function) {
        return this.confirm(title, message, 'warning', yesBtn, noBtn, yesCallback, noCallback);
    }

    private alert(title: string, message: string, type?: SweetAlertIcon) {
        Swal.fire(title, message, type)
    }

    private confirm(title: string, message: string, icon: SweetAlertIcon, yesBtn: string, noBtn: string, yesCallback: Function, noCallback: Function) {
        return Swal.fire({
            title: title,
            text: message,
            icon: icon,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn
        }).then(function (res) {
            if(res.isConfirmed){
                yesCallback();
            }else{
                noCallback();
            }
        }, function (dismiss) {
            noCallback();
        });
    }
    
    public promptText(title: string, text: string, currentValue: string, confirmButtonText: string, cancelButtonText: string, yesCallback: (string) => void, noCallback: () => void) {
        return Swal.fire({
            title: title,
            text: text,
            input: 'text',
            inputValue: currentValue,
            showCancelButton: true,
            cancelButtonText: cancelButtonText,
            confirmButtonText: confirmButtonText,
            showLoaderOnConfirm: true,
            allowOutsideClick: false
        }).then((res)=> {
            // ok
            if(res.isConfirmed){
                yesCallback(res.value);
            }else{
                noCallback();
            }
        }, (dismiss) => {
            noCallback();
        });
    }

    public options(title: string, message: string, options: string[]): Promise<number> {

        return new Promise<number>((resolve, reject) => {

            let html = `${message}<br/>`;

            options.forEach((o, i) => {
                html += `<div class='alertbtn' id='swal-btn-${i}'>${o}</div>`;
            });

            return Swal.fire({
                title: title,
                html: html,
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
                didOpen: s => {
                    options.forEach((o, i) => {
                        document.getElementById(`swal-btn-${i}`).onclick = () => {
                            Swal.close();
                            resolve(i);
                        }

                    });
                },
            });

        })
    }
}
